import {
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
} from "antd";
import TextArea from "antd/es/input/TextArea";

import React, { useState } from "react";

import FormAction from "../../../../../../components/common/FormAction";
import { status, units, users } from "../../data";

function ApplicantSummary({ data }) {
  const [checked, setChecked] = useState(false);
  const onCancel = () => {
    setChecked(false);
  };
  return (
    <div className="applicant-summary">
      <Form
        labelCol={{ span: 8 }}
        colon={false}
        wrapperCol={{ span: 11 }}
        labelWrap={{ span: 8 }}
      >
        <Card title="Applicant Summary">
          <Card
            extra={
              !checked ? (
                <span className="onclick-text" onClick={() => setChecked(true)}>
                  Edit
                </span>
              ) : null
            }
          >
            {checked ? (
              <Row>
                <Col span={24}>
                  <Form.Item label="Status">
                    <Select options={status} defaultValue="Denied"/>
                  </Form.Item>
                  <Form.Item label="Reason For Denial" required>
                    <TextArea rows={3} />
                  </Form.Item>
                  <Form.Item label=" ">
                    <Checkbox>
                      Update status of all applications in group
                    </Checkbox>
                  </Form.Item>
                  <Form.Item label="Unit" required>
                    <Select placeholder="Select..." showSearch allowClear options={units} />
                  </Form.Item>
                  <Form.Item label="Listing Status">
                    <p>--</p>
                  </Form.Item>
                  <Form.Item label="Available">
                    <p>--</p>
                  </Form.Item>
                  <Form.Item label="Desired Move In" required>
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                  <Form.Item label="Assigned User">
                    <Select
                      placeholder="Start typing to search"
                      showSearch
                      allowClear
                      options={users}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <FormAction cancel={onCancel} />
                </Col>
              </Row>
            ) : (
              <Row>
                <Col span={24}>
                  <Form.Item label="Status">
                    <p>{data?.status}</p>
                  </Form.Item>
                  <Form.Item label="Reason For Denial">
                    <pre>{data?.reasonForDenial}</pre>
                  </Form.Item>
                  <Form.Item label="Unit">
                    <p>{data?.unit}</p>
                  </Form.Item>
                  <Form.Item label="Listing Status">
                    <p>{data?.listingStatus}</p>
                  </Form.Item>
                  <Form.Item label="Vacant On">
                    <p>{data?.vacantOn}</p>
                  </Form.Item>
                  <Form.Item label="Desired Move In">
                    <p>{data?.desiredMoveIn}</p>
                  </Form.Item>
                  <Form.Item label="Assigned User">
                    <p>{data?.assignedUser}</p>
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Card>
          <Row>
            <Col span={24}>
              <Form.Item label="Received">
                <p>{data?.received}</p>
              </Form.Item>
              <Form.Item label="Applicant Reported Source">
                <p>{data?.applicantReportedSource}</p>
              </Form.Item>
              <Form.Item label="Residential History">
                <p className="onclick-text">{data?.residentialHistory}</p>
              </Form.Item>
              <Form.Item label="Total Monthly Income">
                <p>
                  <span className="onclick-text">${data?.totalMonthlyIncome}</span> You reviewed 102
                  screening reports last month. Confirm their ability to pay
                  with <span className="onclick-text">Income Verification</span>
                  .
                </p>
              </Form.Item>
              <Form.Item label="Applying With">
                <p>{data?.applyingWith}</p>
              </Form.Item>
              <Form.Item label="Dependents">
                <p className="onclick-text">{data?.dependents}</p>
              </Form.Item>
              <Form.Item label="Pets">
                <p className="onclick-text">{data?.pets}</p>
              </Form.Item>
              <Form.Item label="Attachments">
                <p className="onclick-text">{data?.attachments}</p>
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Form>
    </div>
  );
}

export default ApplicantSummary;
